import { useHistory } from 'react-router-dom';
import {
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import HeaderTitle from '../../components/HeaderTitle/HeaderTitle';
import Loader from '../../components/Loader/Loader';
import { Pagination } from '../../components/Pagination/Pagination';
import { Stats } from '../../components/Stats/Stats';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useSurveySessions, useSurveySessionStats } from '../../hooks/useSurveySessions';
import statsStyles from '../stats/Stats.module.scss';
import styles from './VoiceSurveys.module.scss';
import {
  STATUS_OPTIONS,
  formatDateTime,
  formatDuration,
  formatPercent,
  statusLabel,
} from './surveySessionFormat';

const SurveyStats = () => {
  const { stats } = useSurveySessionStats();
  if (!stats) {
    return null;
  }

  return (
    <div className={statsStyles.statsBar}>
      <Stats title='Calls (30 days)' value={stats.total} />
      <Stats title='Completion rate' value={formatPercent(stats.completion_rate)} />
      <Stats title='Avg duration' value={formatDuration(stats.avg_duration_seconds)} />
      <Stats title='Not interested' value={stats.not_interested} />
    </div>
  );
};

export const VoiceSurveysPage = () => {
  const history = useHistory();
  const query = useQueryParams();
  const page = query.get('page') || '1';
  const status = query.get('status') || '';
  const { data, meta, loading } = useSurveySessions({ page, status });

  const handleStatusChange = (event) => {
    const params = new URLSearchParams();
    if (event.target.value) {
      params.set('status', event.target.value);
    }
    history.push({ search: params.toString() });
  };

  return (
    <>
      <HeaderTitle title={'Voice Surveys'} />
      <div className='page-layout'>
        <div className='header bordered'>
          <div className='header-title'>
            <h1>Voice Surveys</h1>
          </div>
        </div>
        <SurveyStats />
        <div className={styles.filters}>
          <Select size='small' value={status} onChange={handleStatusChange} displayEmpty>
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <Loader isLoading={loading}>
          {data && data.length === 0 && <p className={styles.empty}>No calls found.</p>}
          {data && data.length > 0 && (
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Transcript lines</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((session) => (
                  <TableRow
                    key={session.id}
                    hover
                    className={styles.row}
                    onClick={() => history.push(`/voice-surveys/${session.id}`)}
                  >
                    <TableCell>{formatDateTime(session.created_at)}</TableCell>
                    <TableCell>{session.account?.phone || '-'}</TableCell>
                    <TableCell>
                      {session.collected_data?.name || session.account?.name || '-'}
                    </TableCell>
                    <TableCell>{statusLabel(session.status)}</TableCell>
                    <TableCell>{formatDuration(session.duration_seconds)}</TableCell>
                    <TableCell>{session.transcript_line_count}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Loader>
        {!loading && data && data.length > 0 && (
          <Pagination meta={meta} columns={[]} data={data} />
        )}
      </div>
    </>
  );
};
